import { OrderHelper } from "./OrderHelper"
import { I18N } from "./I18N"
import { BluetoothPrinter } from "./lib/BluetoothPrinter"

export class PrintDialog {

	_target
	_order
	_store
	_completeTaskAction
	_taskBtn

	constructor(target, order, store, completeTaskAction, taskBtn) {
		this._order = order
		this._store = store
		this._completeTaskAction = completeTaskAction
		this._taskBtn = taskBtn
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
	}

	close = () => this.setVisible(false)

	setVisible = visible => {
		if (visible) {
			const isWindows = navigator.userAgent && navigator.userAgent.toLowerCase().includes('windows')
			//const receiptWidthMm = '58'

			let receiptWidthPx = 384 // Width on 58mm roll
			let fontHeightPx = 23 // Font size on 58mm roll
			let receiptWidth = receiptWidthPx + 'px'
			let fontHeight = fontHeightPx + 'px'
			if (isWindows) {
				const receiptWidthMm = '72'
				// let receiptWidthPx = 528 // Width on 80mm roll
				let fontHeightMm = 3.5 // Font size on 80mm roll
				receiptWidth = receiptWidthMm + 'mm'
				fontHeight = fontHeightMm + 'mm'
			}

			const css = OrderHelper.getCss(receiptWidth, fontHeight)
			const innerHtml = OrderHelper.getHtml(this._order, this._store)

			// Render preview Dialog
			this._target.innerHTML = `
				<div class="modalCanvas">
				<div id="printOrderModalShader" class="modalShader"></div>
				<div class="card modal">
					<button id="printOrderCloseBtn" class="closeBtn"><span class="material-icons">close</span></button>
					<div class="dlgTopSpacer"><h2 i18n>Receipt printing</h2></div>
					<div class="btnGroup">
						<button type="button" class="printBtn" i18n>Print</button>
					</div>
					<div class="card" style="width: fit-content;">
						<div>
							<style type="text/css">
								${css}
							</style>
							${innerHtml}
						</div>
					</div>
				</div>
			`
			I18N.translateElement(this._target)
			this._target.removeAttribute('hidden')
			window.scrollTo(0, 0)

			this._target.querySelector('.receipt img').addEventListener('load', () => {

				// Get the receipt height from preview
				const receiptHeightPx = this._target.querySelector('.receipt').offsetHeight
				// Button listeners
				this._target.querySelector('#printOrderModalShader').addEventListener('click', () => this.close())
				this._target.querySelector('#printOrderCloseBtn').addEventListener('click', () => this.close())

				this._target.querySelector('.printBtn').addEventListener('click', ev => {
					if (isWindows) {
						// Use an IFrame to print on Windows
						const iFrameHtml = `
						<html style="margin: 0; padding: 0;">
							<head>
								<style>
									${css}
								</style>
							</head>
							<body style="margin: 0; padding: 0;">
								<div class="receipt">${innerHtml}</div>
								<script>
									addEventListener('afterprint', () => parent.setPrinted())
									document.getElementsByTagName('img')[0].addEventListener('load', () => window.print())
								</script>
							</body>
						</html>
					`

						let iFrameElement = document.createElement('iframe')
						iFrameElement = document.getElementsByTagName('body')[0].appendChild(iFrameElement)
						// Hide iFrame
						iFrameElement.setAttribute('style', 'position: fixed; top: 0; opacity: 0; z-index: -99;')
						// afterprint hadler for iFrame
						window.setPrinted = () => {
							console.debug('Closing iFrame after print')
							iFrameElement.remove()
							if (this._completeTaskAction) {
								this._completeTaskAction(this._taskBtn)
							}
							this.close()
						}
						// Fill iFrame
						iFrameElement.src = "about:blank";
						iFrameElement.contentWindow.document.open();
						iFrameElement.contentWindow.document.write(iFrameHtml);
						iFrameElement.contentWindow.document.close();
					}
					else {
						// Use RawBT to print on Android
						const bluetoothPrinter = new BluetoothPrinter()
						bluetoothPrinter.renderRawBtUrl(css, innerHtml, receiptWidthPx, receiptHeightPx)
							.then(rawBtUrl => {
								// Create an anchor and click it with JavaScript
								const confirmationTargetElement = document.body.appendChild(document.createElement('div'))
								confirmationTargetElement.innerHTML = `<a id="printAnchor" href="${rawBtUrl}">.</a>`
								const printAnchor = document.getElementById('printAnchor')
								try {
									printAnchor.click()
									if (this._completeTaskAction) {
										this._completeTaskAction(this._taskBtn)
									}
									confirmationTargetElement.remove()
									this.close()
								}
								catch (e) {
									console.error(e)
								}
							})
					}
				})
			})
		}
		else {
			this._target.innerHTML = ''
			this._target.setAttribute('hidden', '')
		}
	}
}